import { useRef, useState } from "react";
import { Pencil } from "lucide-react";
import { supabase, BRAND, SHADOW_MODAL, LINE, WHITE, UNREAD, SCRIM_PHOTO } from "./constants";
import { CandidateAvatar, CloseButton } from "./shared";
import ImageCropModal from "./ImageCropModal";

const CandidateAvatarEditable = ({ candidateId, name, photoUrls, setPhotoUrls, isAdmin = false, size = 56, showAlert = false, lang = "en" }) => {
  const photoUrl = photoUrls[candidateId] || null;
  const [lightbox, setLightbox] = useState(false);
  const [cropSrc, setCropSrc] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => setCropSrc(ev.target.result);
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const handleCropConfirm = async (blob) => {
    setUploading(true);
    try {
      const path = `candidate-${candidateId}-${Date.now()}.png`;
      const { error: uploadError } = await supabase.storage.from("candidate-photos").upload(path, blob, { upsert: true, contentType: "image/png" });
      if (uploadError) throw uploadError;
      const { data } = supabase.storage.from("candidate-photos").getPublicUrl(path);
      setPhotoUrls(prev => ({ ...prev, [candidateId]: data.publicUrl }));
      await supabase.from("candidate_photos").upsert({ candidate_id: candidateId, photo_url: data.publicUrl, updated_at: new Date().toISOString() });
      setCropSrc(null);
    } catch (err) { console.error(err); }
    setUploading(false);
  };

  return (
    <div style={{ position: "relative", flexShrink: 0 }}>
      {photoUrl
        ? <img src={photoUrl} alt={name} onClick={() => setLightbox(true)} style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", border: `1.5px solid ${LINE}`, display: "block", cursor: "pointer" }} />
        : <CandidateAvatar name={name} size={size} />
      }
      {isAdmin && <button onClick={() => fileInputRef.current?.click()} title={lang === "es" ? "Subir foto" : "Upload photo"} style={{ position: "absolute", bottom: -2, right: -2, width: 18, height: 18, borderRadius: "50%", background: BRAND, border: `2px solid ${WHITE}`, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: WHITE, padding: 0 }}><Pencil size={10} strokeWidth={2} /></button>}
      {showAlert && <span title={lang === "es" ? "Nuevo" : "New"} style={{ position: "absolute", top: -2, right: -2, background: UNREAD, borderRadius: "50%", width: 10, height: 10, boxShadow: `0 0 0 2px ${WHITE}`, zIndex: 1 }} />}
      <input ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFileChange} />

      {cropSrc && <ImageCropModal lang={lang} imageSrc={cropSrc} uploading={uploading} onConfirm={handleCropConfirm} onCancel={() => setCropSrc(null)} />}

      {lightbox && photoUrl && (
        <div onClick={() => setLightbox(false)} style={{ position: "fixed", inset: 0, background: SCRIM_PHOTO, zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-out" }}>
          <img src={photoUrl} alt={name} style={{ maxWidth: "80vw", maxHeight: "80vh", borderRadius: 16, boxShadow: SHADOW_MODAL, objectFit: "contain" }} onClick={e => e.stopPropagation()} />
          <CloseButton onClick={() => setLightbox(false)} label={lang === "es" ? "Cerrar" : "Close"} style={{ position: "absolute", top: 24, right: 24, width: 40, height: 40, color: WHITE }} />
        </div>
      )}
    </div>
  );
};

export default CandidateAvatarEditable;
